export const capitalizeFirstLetter = (text: string) => {
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const getInitials = (text: string) => {
	let initial = '';
	text.split(' ').forEach((nameText) => (initial += nameText?.[0] ?? ''));
	return initial.toUpperCase();
};
